import React from "react";
import { Paper, Divider } from "@material-ui/core";
import clsx from "clsx";

import useStyles from "./stylesItem";
import SubTitle from "../SubTitle";

const InfoItem = ({ title, data, footer }) => {
  const classes = useStyles();
  const numberPaperHeight = clsx(classes.paper, classes.numberPaper);
  return (
    <>
      <Paper className={numberPaperHeight} >
        <p className={classes.tituloCards}>{title}</p>
        <SubTitle style={{ textAlign: "right" }}>{data}</SubTitle>
        <Divider style={{ marginTop: "5%" }} />
        <p className={classes.annotationText}>{footer}</p>
      </Paper>
    </>
  );
};

export default InfoItem;
